export default "__VITE_ASSET__CndlzReG__"